<script setup>
// core
import {useStore} from "vuex";
// components
import ButtonLoading from "@/components/Recurring/ButtonLoading.vue";
import CallNumberView from "@/components/Telephony/CallNumberView.vue";
import {computed, ref, getCurrentInstance} from "vue";

const {proxy} = getCurrentInstance()
const store = useStore()
const isLoading = ref(false)

const dialogParams = computed(() => store.state.dialogParams)

const onDelete = async () => {
    isLoading.value = true

    try {
        await store.dispatch('telephony/deleteWebhook', {
            number: dialogParams.value?.number,
            moshaToast: proxy.$moshaToast,
        })

        if (!!store.getters.getNextDialog) {
            store.commit("setDialog", store.getters.getNextDialog);
            store.commit("setNextDialog", "");
        } else {
            store.commit("closeDialog");
        }
    } finally {
        isLoading.value = false
    }
}
</script>

<template>
    <slot name="header_close"/>

    <div class="wrapper_dialog">
        <h3 class="title">
            {{ $t('telephony.connected_numbers.webhooks.dialog_delete_title') }}
            <div class="number-block">
                <CallNumberView :number="dialogParams?.number"/>
            </div>
        </h3>

        <div class="content">
            <p class="confirm">{{ $t("telephony.connected_numbers.webhooks.delete_confirm") }}</p>

            <div class="action_container">
                <ButtonLoading :loading="isLoading" @click="onDelete">
                    {{ $t("common.delete") }}
                </ButtonLoading>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@use "@/styles/dialog-form.scss";
</style>
